/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('BibliotecaFormAdminController', BibliotecaFormAdminController);

    /* @ngInject */
    function BibliotecaFormAdminController($timeout, $state, itemData, previousParams, Principal, AlertService) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        vm.item = itemData;
        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        if (vm.mode === 'edit') {
            Principal.hasAuthority("ROLE_ADMIN").then(function (esAdmin) {
                if (!esAdmin) {
                    AlertService.warning("admin.biblioteca.error.unauthorized", null, 0);
                }
            });
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                $state.go('admin/biblioteca/list', previousParams);
            });
        };
    }

})(angular);
